<div class="flex flex-row justify-end items-center folder-controls">
  <scope-ui-input
    #searchInput
    [initialValue]="searchString"
    icon="search"
    cancelIcon="cancel"
    inputLabel="Search"
    inputClass="search-field"
    (onCancel)="searchString = undefined"
    (onEnter)="searchString = $event" />

  <scope-ui-options-menu
    [menuOptions]="createMenuOptions"
    buttonText="Create new"
    class="ml-4" />

  <button
    class="library-actions-button"
    [matMenuTriggerFor]="folderMenu">
    <mat-icon class="material-symbols-rounded">more_vert</mat-icon>
  </button>
  <mat-menu
    #folderMenu="matMenu"
    backdropClass="library-options-menu">
    <button
      *ngFor="let option of menuOptions"
      mat-menu-item
      [has-privilege]="option.hasPrivilege()"
      (click)="option.callback()">
      <mat-icon class="material-symbols-rounded orange">{{ option.icon() }}</mat-icon>
      <span class="library-option-name">{{ option.name() }}</span>
    </button>
  </mat-menu>
</div>

<div class="folder-overview">
  <scope-ui-table
    *ngIf="tableConfig"
    tableClass="row-gaps shrunk-table"
    [loading]="tableConfig.isLoading"
    [loggedInUser]="authService.loggedInUser"
    [data]="tableConfig.mappedDataSource | filter: searchString : 'name'"
    [displayedColumns]="tableConfig?.displayedColumns"
    [rowGaps]="true"
    [expandable]="true"
    [condensed]="true"
    [showDescription]="true"
    [descriptionEditableFn]="scopeEditableFn"
    [selectMode]="ScopeUiTableSelectMode.NAME"
    [addToggleListColumn]="true"
    [menuOptions]="scopeMenuOptions"
    (onExpand)="onExpandScope($event)"
    (onSelect)="onSelectScope($event)"
    (onSaveElement)="onUpdateScope($event)"
    (onToggle)="onTogglePreference($event)">
    <ng-template let-element>
      <div
        *ngIf="scopeDetailsMap?.[element.entity.identity?.id] as scopeDetails"
        class="tbody table-content w-full">
        <table-loader
          [loading]="scopeDetails.isLoading"
          [condensed]="true"
          [amountOfRows]="0">
        </table-loader>
        <scope-deliverables
          *ngIf="!scopeDetails.isLoading && scopeDetails.scope"
          [hidden]="!scopeDetails.scope.deliverables.length && !scopeDetails.scope.sections.length"
          [level]="2"
          [config]="getConfig(scopeDetails.scope)"
          [deliverables]="scopeDetails.scope.deliverables"
          (onExpandDeliverable)="onExpandDeliverable($event)"
          (onUpdateDeliverable)="onUpdateDeliverable($event, element.entity)"
          (onUpdateComponent)="onUpdateComponent($event, element.entity)">
        </scope-deliverables>
      </div>
    </ng-template>
  </scope-ui-table>
</div>
